{
  "post-office.aurum.jira-assets-schemas-display-name.body": [
    {
      "type": 0,
      "value": "Clarify and localise entities without breaking AQL or integrations."
    }
  ],
  "post-office.aurum.jira-assets-schemas-display-name.headline": [
    {
      "type": 0,
      "value": "Display names are here"
    }
  ],
  "post-office.aurum.jira-assets-schemas-display-name.primary-action": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ]
}